var map = {
	"./cat": "JLWb",
	"./cat.js": "JLWb",
	"./cd": "vvSx",
	"./cd.js": "vvSx",
	"./chmod": "aXkG",
	"./chmod.js": "aXkG",
	"./common": "hP1I",
	"./common.js": "hP1I",
	"./cp": "VJ6a",
	"./cp.js": "VJ6a",
	"./dirs": "lgjc",
	"./dirs.js": "lgjc",
	"./echo": "abFo",
	"./echo.js": "abFo",
	"./error": "IWiJ",
	"./error.js": "IWiJ",
	"./exec": "f4lP",
	"./exec.js": "f4lP",
	"./find": "/pyW",
	"./find.js": "/pyW",
	"./grep": "b1GN",
	"./grep.js": "b1GN",
	"./head": "NZcQ",
	"./head.js": "NZcQ",
	"./ln": "5ccz",
	"./ln.js": "5ccz",
	"./ls": "J43z",
	"./ls.js": "J43z",
	"./mkdir": "WsgH",
	"./mkdir.js": "WsgH",
	"./mv": "3oIr",
	"./mv.js": "3oIr",
	"./popd": "HtqY",
	"./popd.js": "HtqY",
	"./pushd": "euJy",
	"./pushd.js": "euJy",
	"./pwd": "v5BX",
	"./pwd.js": "v5BX",
	"./rm": "7cWb",
	"./rm.js": "7cWb",
	"./sed": "fQif",
	"./sed.js": "fQif",
	"./set": "Mr59",
	"./set.js": "Mr59",
	"./sort": "u2oJ",
	"./sort.js": "u2oJ",
	"./tail": "EOQn",
	"./tail.js": "EOQn",
	"./tempdir": "pCA+",
	"./tempdir.js": "pCA+",
	"./test": "KSi2",
	"./test.js": "KSi2",
	"./to": "w906",
	"./to.js": "w906",
	"./toEnd": "SPE2",
	"./toEnd.js": "SPE2",
	"./touch": "2fRZ",
	"./touch.js": "2fRZ",
	"./uniq": "P9Qr",
	"./uniq.js": "P9Qr",
	"./which": "5Me2",
	"./which.js": "5Me2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hDwr";


//////////////////
// WEBPACK FOOTER
// ./node_modules/_shelljs@0.7.8@shelljs/src ^\.\/.*$
// module id = hDwr
// module chunks = 1